import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss',
  standalone: true,
  imports: [
    TranslateModule,
  ]
})
export class TitleComponent implements OnInit {
  public translate = inject(TranslateService);

  @Input() title!: string; // Propriedade que recebe o dado do pai


  constructor() {}

  //#region Inicialização
  ngOnInit() {}

  //#endregion

  //#region Actions

  //#endregion
}
